module.exports = __webpack_public_path__ + "036.a3079cdf.png";